﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartVaultABI = void 0;
class SmartVaultABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_maxFee",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_collWithdrawal",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_debtChange",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bool",
                        "name": "isDebtIncrease",
                        "type": "bool"
                    },
                    {
                        "internalType": "address",
                        "name": "_upperHint",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "_lowerHint",
                        "type": "address"
                    }
                ],
                "name": "adjustMainVaultExpert",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "approve",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "manager_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "llVaultManager_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "feeRecipient_",
                        "type": "address"
                    },
                    {
                        "internalType": "string",
                        "name": "name_",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol_",
                        "type": "string"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "value",
                        "type": "uint256"
                    }
                ],
                "name": "Approval",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "maxMainFee_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minLoanValue_",
                        "type": "uint256"
                    }
                ],
                "name": "borrow",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "loanValue",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "maxMainFee_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "forVault_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeCorrectionIndex_",
                        "type": "uint256"
                    }
                ],
                "name": "borrowInternal",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "loanValue",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "checkMainVaultChanges",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "claimCollateral",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "claimMainCollateralExpert",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "closeMainVaultExpert",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "repayDebtValue_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "needReturnColl_",
                        "type": "uint256"
                    }
                ],
                "name": "closeVault",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "anonymous": false,
                "inputs": [],
                "name": "CloseVault",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "startTimestamp",
                        "type": "uint256"
                    }
                ],
                "name": "CloseVaultPreparing",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "subtractedValue",
                        "type": "uint256"
                    }
                ],
                "name": "decreaseAllowance",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "plsv_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minLoan_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minColl_",
                        "type": "uint256"
                    }
                ],
                "name": "detokenize",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "addedValue",
                        "type": "uint256"
                    }
                ],
                "name": "increaseAllowance",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousManager",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "ManagmentshipTransferred",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousOwner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "OwnershipTransferred",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "usdlAmount_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minCollValue_",
                        "type": "uint256"
                    }
                ],
                "name": "repayDebt",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "repayDebtForRepay",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "usdlAmount_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "forVault_",
                        "type": "address"
                    }
                ],
                "name": "repayDebtInternal",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "feeRecipient_",
                        "type": "address"
                    }
                ],
                "name": "setFeeRecipient",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "maxFee_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "debtAmount_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "upperHint_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "lowerHint_",
                        "type": "address"
                    }
                ],
                "name": "start",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "startCloseVaultPreparing",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "loanToPLSV_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minPLSV_",
                        "type": "uint256"
                    }
                ],
                "name": "tokenize",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "transfer",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "value",
                        "type": "uint256"
                    }
                ],
                "name": "Transfer",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "transferFrom",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newManager_",
                        "type": "address"
                    }
                ],
                "name": "transferManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner_",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "withdrawToken",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    }
                ],
                "name": "allowance",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "account",
                        "type": "address"
                    }
                ],
                "name": "balanceOf",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "value_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "borrowRate_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeCorrectionIndex_",
                        "type": "uint256"
                    }
                ],
                "name": "calcFee",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "debtAmountBase",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "fee",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "closeVaultTimestamp",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "debtForRepay",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "decimals",
                "outputs": [
                    {
                        "internalType": "uint8",
                        "name": "",
                        "type": "uint8"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "extSyncDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "FCRIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "feeRecipient",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "forVault_",
                        "type": "address"
                    }
                ],
                "name": "getDebtCollIndexed",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "debt",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "coll",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "forVault_",
                        "type": "address"
                    }
                ],
                "name": "getStats",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "debt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "coll",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "totalDebt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "FCRIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "redeemDeltaDebtIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "redeemDeltaCollIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "debtForRepay",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "plsvBalance",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "plsvSupply",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "totalLiqidatedColl",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "closeVaultTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "addrs",
                                "type": "address"
                            },
                            {
                                "internalType": "string",
                                "name": "name",
                                "type": "string"
                            },
                            {
                                "internalType": "bool",
                                "name": "isLiquidated",
                                "type": "bool"
                            },
                            {
                                "internalType": "bool",
                                "name": "needExtSync",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct SmartVault.SmartVaultFullInfo",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "index_",
                        "type": "uint256"
                    }
                ],
                "name": "getVaultFromVaultOwnersArray",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "debt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "coll",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "deltaDebtIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "deltaCollIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint128",
                                "name": "arrayIndex",
                                "type": "uint128"
                            }
                        ],
                        "internalType": "struct SmartVault.Vault",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "forVault_",
                        "type": "address"
                    }
                ],
                "name": "getVaultIndexed",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "debt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "coll",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "deltaDebtIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "deltaCollIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint128",
                                "name": "arrayIndex",
                                "type": "uint128"
                            }
                        ],
                        "internalType": "struct SmartVault.Vault",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getVaultsCount",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "initFCRIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "isLiquidated",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llBorrower",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llUsdlERC20",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llVaultManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "manager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "name",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "redeemDeltaCollIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "redeemDeltaDebtIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "symbol",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalLiqidatedColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "VaultOwners",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "Vaults",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "debt",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "coll",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "deltaDebtIndex",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "deltaCollIndex",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint128",
                        "name": "arrayIndex",
                        "type": "uint128"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            }
        ];
    }
}
exports.SmartVaultABI = SmartVaultABI;
//# sourceMappingURL=SmartVaultABI.js.map